import { enableGroupLinkingAction as enableGroupLinkingOperation } from 'editor/src/store/variants/slice';

export default enableGroupLinkingOperation;
